/**
 * Palette roles a control accepts — armory's `Enums/Color`, kept one-to-one so
 * `color={Color.secondary}` call sites port unchanged. String literals work too:
 * the type is the union of the values.
 */
export const Color = {
  primary: 'primary',
  secondary: 'secondary',
  inherit: 'inherit',
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
} as const;

export type Color = (typeof Color)[keyof typeof Color];
